import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import s from './CreateEmailTemplateModal.scss'
import { TextEditor } from 'components/ideal-core-ui'

const CreateEmailTemplateModal = ({
  setIsCreateEmailTemplateModalVisible,
  isCreateEmailTemplateModalVisible,
  saveTemplate,
  setIsEditedTemplate,
  template,
  hasSubjectLine
}) => {
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isCreateEmailTemplateModalVisible}
        size="xl"
      >
        <ModalHeader className={s.modalHeader}>Add Email Template</ModalHeader>
        <ModalBody className={s.modalBody}>
          <div className={s.content}>
            <TextEditor
              template={template?.content}
              title={template?.title}
              subject={template?.subject}
              hasSubject={hasSubjectLine}
              hasTitle
              actions={[
                {
                  text: 'Save',
                  cb: (body, title, subject, destroyEditor) => {
                    saveTemplate(body, title, subject, destroyEditor)
                  },
                  className: s.saveBtn
                },
                {
                  text: 'Cancel',
                  cb: (body, title, subject, destroyEditor) => {
                    destroyEditor && destroyEditor()
                    setIsCreateEmailTemplateModalVisible(false)
                    setIsEditedTemplate(null)
                  },
                  className: s.cancelBtn
                }
              ]}
            />
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default CreateEmailTemplateModal
